/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import { getCatalogId } from '@msdyn365-commerce/core';
import { getAttributeValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
/**
 * GetProductAttributesCartlines Input Action
 */
export class GetProductAttributesCartlinesInput implements Msdyn365.IActionInput {
    public productID: number;
    constructor(productID: number) {
        this.productID = productID;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `getProductAttributeCartline`;
    public getCacheObjectType = () => 'getProductAttributeCartline';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetProductAttributesCartlinesData {
    productAttributes: AttributeValue[];
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProductAttributeCartlineAction(
    input: GetProductAttributesCartlinesInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetProductAttributesCartlinesData> {
    const catalogId = getCatalogId(ctx.requestContext);
    const channelID = +ctx.requestContext.apiSettings.channelId;

    const attributeValueResponse = await getAttributeValuesAsync({ callerContext: ctx }, input.productID, channelID, catalogId);
    return { productAttributes: attributeValueResponse };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetProductAttributesCartlinesData>>getProductAttributeCartlineAction,
    id: 'GetProductAttributesCartlines'
});
